module.exports = __webpack_public_path__ + "static/media/github.9c6d3481.svg";